"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M3.7 6.7a2 2 0 0 1 2-2h8.6a2 2 0 0 1 2 2v5.346a2 2 0 0 1-2 2h-3.995a1 1 0 0 0-.56.171l-1.381.933a1 1 0 0 1-1.43-.337l-.147-.26a1 1 0 0 0-.87-.507h-.218a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 7.2A3.2 3.2 0 0 1 6.2 4h7.6A3.2 3.2 0 0 1 17 7.2v4.258a3.2 3.2 0 0 1-3.2 3.2h-3.152a.73.73 0 0 0-.55.249l-.907 1.032c-.984 1.119-2.829.423-2.829-1.066a.215.215 0 0 0-.215-.215h-.345A2.8 2.8 0 0 1 3 11.856zm3.2-1.8a1.8 1.8 0 0 0-1.8 1.8v4.656c0 .774.627 1.402 1.402 1.402h.345c.892 0 1.616.723 1.616 1.615 0 .198.245.29.376.142l.907-1.032a2.133 2.133 0 0 1 1.602-.725H13.8a1.8 1.8 0 0 0 1.8-1.8V7.2a1.8 1.8 0 0 0-1.8-1.8z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MessageIcon20.js.map